import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import ProductCard from "./ProductCard";
import { useProductStore } from "../../store/productStore";
import Loader from "../loader/Loader";

// Кастомные стрелки
const CustomArrow = ({ direction, onClick }: { direction: "left" | "right"; onClick?: () => void }) => {
    return (
        <button
            onClick={onClick}
            style={{ zIndex: 10 }}
        >
            {direction === "left" ? (
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 12.4941H5M5 12.4941L12 19.4941M5 12.4941L12 5.49414" stroke="#1E1E1E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ) : (
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12.4941H19M19 12.4941L12 5.49414M19 12.4941L12 19.4941" stroke="#1E1E1E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            )}
        </button>
    );
};

function ProductSlider() {
    const { products, filters, fetchAllProducts, loading: productsLoading, error: productsError } = useProductStore();
    const sliderRef = useRef<Slider | null>(null);

    useEffect(() => {
        fetchAllProducts();
    }, [filters, fetchAllProducts]);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false, // Отключаем стандартные стрелки
        responsive: [
            {
                breakpoint: 1024, // Для планшетов
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768, // Для мобильных устройств
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480, // Для маленьких экранов
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    };

    return (
        <div className="container mx-auto px-4 py-8">
            {/* Заголовок с кастомными стрелками */}
            <div className="relative flex justify-between items-center mb-4">
                <h2 className="text-2xl font-bold">Новинки</h2>
                <div className="flex space-x-2">
                    <CustomArrow direction="left" onClick={() => sliderRef.current?.slickPrev()} />
                    <CustomArrow direction="right" onClick={() => sliderRef.current?.slickNext()} />
                </div>
            </div>

            {/* Слайдер */}
            {productsLoading ? (
                <Loader />
            ) : productsError ? (
                <p>Ошибка загрузки товаров</p>
            ) : (
                <Slider {...settings} ref={sliderRef}>
                    {products?.map((product) => (
                        <div key={product.id} className="p-4">
                            <ProductCard product={product} />
                        </div>
                    ))}
                </Slider>
            )}
        </div>
    );
}

export default ProductSlider;
